// src/com/auto_cpp_info/AutoCppInfoDict.js
import { InputType, TableColumnType } from "../../value/AppConst";

// DC별 일일 물동량 볼륨, auto_cpp_info
const DictMore = {
    dayTotVol : {
		id: 'dayTotVol', label: '당일 전체 볼륨',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    tpc : {
		id: 'tpc', label: 'TPC',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // double
    fillRate : {
		id: 'fillRate', label: 'Fill Rate',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // double
    leftOver : {
		id: 'leftOver', label: 'Left Over', // 'AUTO_PLAN_UPLOAD.REST_OVER_PT 참조',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    processStep : {
		id: 'processStep', label: '처리단계', // 'P(시작), F(완료)',
		required: false, toAdd: true, toEdit: true,
	}, // enum('P','D','F')
    vehTotCnt : {
		id: 'vehTotCnt', label: '배차대수',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    dcName : {
		id: 'dcName', label: '물류센터',
	}, // varchar(20)

};

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    dcCd : {
		id: 'dcCd', label: '물류센터', required: true, toAdd: true, toEdit: true,
	}, // varchar(3)
    planDate : {
		id: 'planDate', label: '배차일자', required: true, toAdd: true, toEdit: true,
	}, // date
    cppTot : {
		id: 'cppTot', label: 'CPP수량',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0.1 && value <= 200.0},
	}, // double
};


/**
 * AUTO_CPP_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-11-01 16:46:30 using DbdbTap
 */
export const AutoCppInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: 'CPP수량 등록 오류',
        Edit: 'CPP수량 수정 오류',
        Remove: '출고예정수량 정보 삭제 오류',
        Get: '출고예정수량 정보 조회 오류',
    },
    tableProps: {
        tableId: 'autoCppInfoTable',
        uniqueKey: 'planDate', // dcCd로 필터링하므로 날짜만 유니크키로 사용.
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'dcName', label: DictMore.dcName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'planDate', label: Dict.planDate.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'processStep', label: DictMore.processStep.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dayTotVol', label: DictMore.dayTotVol.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'cppTot', label: Dict.cppTot.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'tpc', label: DictMore.tpc.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'fillRate', label: DictMore.fillRate.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'leftOver', label: DictMore.leftOver.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'vehTotCnt', label: DictMore.vehTotCnt.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            // { id: 'updateDate', label: "updateDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'regDate', label: "regDate", width: 120, show: true, option:{align: 'inherit', print:(r,i,v)=>v?v.substring(0,16):'-'} },
            // { id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
